import { Outlet } from 'react-router'

import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { EventsExplorer, TracesExplorer } from '@ui/pages/explore'
import { RouteNamesEnum } from '@ui/router/routes'

export const ExplorerRoutes = () => {
  return {
    name: RouteNamesEnum.EXPLORER,
    path: 'explore',
    element: <Outlet />,
    handle: {
      crumb: (data: ExtraParams) => (
        <Breadcrumb crumbStyle={data.crumbStyle} to={`/instances/${data.instanceId}/explore/events`} label="Explore" />
      ),
    },
    children: [
      {
        name: RouteNamesEnum.EVENTS_EXPLORER,
        path: 'events',
        element: <EventsExplorer />,
        handle: {
          crumb: (data: ExtraParams) => (
            <Breadcrumb
              crumbStyle={data.crumbStyle}
              to={`/instances/${data.instanceId}/explore/events`}
              label="All Events"
            />
          ),
        },
      },
      {
        name: RouteNamesEnum.TRACES_EXPLORER,
        path: 'traces',
        element: <TracesExplorer />,
        handle: {
          crumb: (data: ExtraParams) => (
            <Breadcrumb
              crumbStyle={data.crumbStyle}
              to={`/instances/${data.instanceId}/explore/traces`}
              label="Traces"
            />
          ),
        },
      },
    ],
  }
}
